import React from "react";
import { useLanguage } from "../context/LanguageContext";

const JudicialExpertise = () => {
  const { t } = useLanguage();

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <section
      id="expertise"
      data-testid="expertise-section"
      className="section-padding bg-white"
    >
      <div className="container-page">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5">
            <div className="relative">
              <div className="aspect-square rounded-2xl overflow-hidden border border-border bg-white flex items-center justify-center p-8 md:p-12">
                <img
                  src="https://customer-assets.emergentagent.com/job_orthopedie-pro/artifacts/x4e1tbch_attachment_130189480.jpeg"
                  alt="Orthopaedic Qualified Medical Evaluators — Expertise judiciaire"
                  className="h-full w-full object-contain"
                  loading="lazy"
                  width="900"
                  height="900"
                />
              </div>
              <div className="absolute -right-4 -bottom-4 rounded-xl bg-[#0A192F] text-white p-5 shadow-2xl max-w-[240px]">
                <i className="fa-solid fa-scale-balanced text-[#FF5A1F] text-xl" aria-hidden="true"></i>
                <p className="mt-2 font-display font-bold text-sm leading-tight">
                  Orthopaedic Qualified Medical Evaluator
                </p>
                <p className="mt-1 text-[11px] text-white/70 leading-tight">
                  Rigueur & objectivité médicale
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="chip mb-5">{t.expertise.eyebrow}</span>
            <h2
              data-testid="expertise-title"
              className="font-display font-black text-4xl sm:text-5xl text-navy leading-[1.05]"
            >
              {t.expertise.title}
            </h2>
            <p className="mt-5 text-base md:text-lg text-foreground/75 leading-relaxed">
              {t.expertise.lead}
            </p>

            <ul className="mt-8 space-y-3">
              {t.expertise.missions.map((m, i) => (
                <li
                  key={i}
                  data-testid={`expertise-mission-${i}`}
                  className="flex items-start gap-3 rounded-lg border border-border bg-[#F8FAFC] p-4"
                >
                  <div className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-[#FF5A1F]/10 text-[#FF5A1F]">
                    <i className="fa-solid fa-gavel text-sm" aria-hidden="true"></i>
                  </div>
                  <span className="text-sm md:text-base text-foreground/85">{m}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <button
                type="button"
                data-testid="expertise-cta"
                onClick={() => scrollToId("contact")}
                className="btn-primary"
              >
                <i className="fa-solid fa-envelope-open-text" aria-hidden="true"></i>
                {t.expertise.contactCta}
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default JudicialExpertise;
